// import * as Sentry from "@sentry/nextjs";

/* eslint-disable  @typescript-eslint/no-explicit-any */
// export default function SentryCaptureException(error: any) {
//   Sentry.captureException(error);
// }

/* eslint-disable  @typescript-eslint/no-explicit-any */
export function devLogError(error: any) {
  if (process.env.NEXT_PUBLIC_ENVIROMENT === "develop") {
    console.error(error);
  }
}
